<template>
  <div class="warranty">
    <Loader
      v-if="loaderEnabled"
      :logo="loaderLogo"
    ></Loader>
    <KTCodePreview v-bind:title="title">
      <template v-slot:toolbar>
        <div class="row align-items-center">
          <b-col class="d-flex justify-content-end">
            <b-dropdown
              v-if="checkPermission('WARRANTY_UPDATE')"
              size="sm"
              class="mr-2"
              variant="warning"
              right
              :disabled="!countWarrantySelected"
            >
              <template slot="button-content">
                <span class="font-weight-bolder">
                  <span class="count-status badge badge-circle badge-white mr-1">{{
                    countWarrantySelected
                  }}</span>
                  Đã chọn
                </span>
              </template>
              <b-dropdown-item @click="showModalChangeStatus">
                <i class="fa-solid fa-arrows-repeat-1"></i> Đổi trạng thái
              </b-dropdown-item>
            </b-dropdown>
          </b-col>
        </div>
      </template>
      <template v-slot:preview>
        <warranty-search-bar
          :params="apiParams"
          :page-size="selectedPageSize"
          :status-options="statusOptions"
          :option-stores="optionStores"
          :all-option-stores="allOptionStores"
          :option-page-size="optionPageSize"
          :is-loading="isLoading"
          :warranty-service-options="warrantyServiceOptions"
          :list-company="listCompany"
          @filter="onFilter"
          @reset="onReset"
          @page-size-change="onPageSizeChange"
        />
        <warranty-list-table
          detail-mode="dispatch"
          :items="listItem"
          :fields="fields"
          :is-loading="isLoading"
          :total-items="totalItems"
          :number-of-page="numberOfPage"
          :current-page="currentPage"
          :limit="limit"
          :can-edit="checkPermission('WARRANTY_UPDATE')"
          :can-delete="false"
          :selectable="checkPermission('WARRANTY_UPDATE')"
          :selected-ids="selectedWarrantyIds"
          :can-create-lending-stock-slip="checkPermission('WARRANTY_UPDATE')"
          :can-create-outsource="true"
          :can-edit-status="checkPermission('WARRANTY_UPDATE')"
          :can-complete="checkPermission('WARRANTY_COMPLETED')"
          :can-return="checkPermission('WARRANTY_UPDATE')"
          :can-change-store="true"
          :can-update-unlimit="checkPermission('WARRANTY_UPDATE_UNLIMIT')"
          :current-store-id="currentStoreId"
          @edit="editItem"
          @view-detail="viewWarrantyDetail"
          @page-change="onPageChange"
          @selection-change="selectedWarrantyIds = $event"
          @complete-warranty="onCompleteWarranty"
          @return-warranty="onReturnWarranty"
          @open-change-status-modal="onOpenChangeStatusModal"
          @create-outsource="openOutsourceForm"
          @view-outsource="viewOutsource"
          @create-lending-stock-slip="onCreateLendingStockSlip"
          @change-store="onOpenChangeStore"
          @confirm-transfer="onConfirmTransfer"
        />
        <outsource-form-modal
          ref="outsourceFormRef"
          :warranty="selectedWarrantyForOutsource"
          @created="onOutsourceCreated"
        />
        <warranty-change-status-modal
          v-if="checkPermission('WARRANTY_UPDATE')"
          ref="warrantyChangeStatusModalRef"
          :selected-items="selectedWarrantyItems"
          @refresh="onRefreshWarranty"
        />
      </template>
    </KTCodePreview>

    <WarrantyChangeStoreModal
      v-model="showChangeStoreModal"
      :warranty="changeStoreWarranty"
      :option-stores="allOptionStores"
      :busy="isChangingStore"
      @save="onSaveChangeStore"
      @hidden="changeStoreWarranty = null"
    />
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue'
import { SET_BREADCRUMB } from '@/core/services/store//modules/breadcrumbs.module'
import { showDeleteAlert } from '@/utils/sweet-alert2'
import { mapGetters } from 'vuex'
import Loader from '@/view/content/Loader.vue'
import permissionMixin from '@/view/mixins/permission.mixin'
import { formatDBDate } from '@/utils/date'
import { makeToastFaile, makeToastSuccess, handleError } from '@/utils/common'
import {
  getWarranties,
  changeWarrantyStore,
  confirmWarrantyTransfer,
  bulkUpdateWarrantyStatus,
  getWarrantyServices,
} from './utils/warrantyApi'
import { checkHasActiveOutsource } from './outsource/warrantyOutsourceApi'
import { mapWarrantyListItem } from './utils/listHelpers'
import WarrantySearchBar from './components/WarrantySearchBar.vue'
import WarrantyListTable from './components/WarrantyListTable.vue'
import WarrantyChangeStatusModal from './components/WarrantyChangeStatusModal.vue'
import OutsourceFormModal from './outsource/components/OutsourceFormModal.vue'
import WarrantyChangeStoreModal from './components/WarrantyChangeStoreModal.vue'
import apiCommonMixin from '@/view/mixins/api-common.mixins'
import { WARRANTY_TRANSFER_STATUS, WARRANTY_RECEPTION_STATUS, PAGE_ACTION } from '@/utils/enum'

export default {
  mixins: [permissionMixin, apiCommonMixin],
  data() {
    return {
      selectedWarrantyForOutsource: null,
      selectedWarrantyIds: [],
      modalDesc: 'Bạn có chắc xoá bản ghi',
      modalTitle: 'Xoá ',
      optionStores: [],
      listCompany: [],
      apiParams: {
        code: null,
        imeiCode: null,
        customerPhone: null,
        customerName: null,
        startDate: null,
        endDate: null,
        status: null,
        storeIds: [],
        previousStoreIds: [],
        criteriaIds: [],
        transferStatus: [],
        productName: null,
        primaryTechnicianId: null,
        inspectedByEmployeeId: null,
        warrantyServiceId: null,
        companyId: null,
        creditUnitIds: [],
        paymentCode: null,
      },
      allOptionStores: [],
      listItem: [],
      numberOfPage: 1,
      totalItems: 0,
      selectedPageSize: null,
      limit: 10,
      optionPageSize: [10, 25, 50, 100],
      fields: [
        {
          key: 'id',
          label: 'ID',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
          thStyle: { width: '6%' },
        },
        { key: 'imeiCode', label: 'Sản phẩm', sortable: false, thStyle: { width: '15%' } },
        { key: 'customerPhone', label: 'Khách hàng', sortable: false, thStyle: { width: '10%' } },
        {
          key: 'statusName',
          label: 'Trạng thái',
          sortable: false,
          tdClass: 'text-center',
          thStyle: { width: '12%' },
        },
        { key: 'info', label: 'Thông tin', sortable: false, thStyle: { width: '20%' } },
        {
          key: 'note',
          label: 'Ghi chú',
          sortable: false,
          thClass: 'note-cell',
          tdClass: 'note-cell',
          thStyle: { width: '15%' },
        },
        { key: 'storeName', label: 'Tại', sortable: false, thStyle: { width: '10%' } },
        {
          key: 'paymentStatus',
          label: 'Thanh toán',
          sortable: false,
          tdClass: 'text-center',
          thClass: 'text-center',
          thStyle: { width: '10%' },
        },
        { key: 'actions', label: '', sortable: false, thStyle: { width: '5%' } },
      ],
      statusOptions: [
        { id: 'RECEIVING', name: 'Đang tiếp nhận' },
        { id: 'REPAIRING', name: 'Đang sửa' },
        { id: 'REPAIRED', name: 'Đã sửa' },
        { id: 'COMPLETED', name: 'Hoàn thành' },
        { id: 'RETURNED', name: 'Đã trả' },
        { id: 'REJECTED', name: 'Đã từ chối' },
      ],
      isLoading: false,
      warrantyServiceOptions: [],
      showChangeStoreModal: false,
      changeStoreWarranty: null,
      isChangingStore: false,
      currentStoreId: null,
    }
  },
  components: {
    KTCodePreview,
    Loader,
    WarrantySearchBar,
    WarrantyListTable,
    WarrantyChangeStatusModal,
    OutsourceFormModal,
    WarrantyChangeStoreModal,
  },
  computed: {
    countWarrantySelected() {
      return this.selectedWarrantyIds.length
    },
    selectedWarrantyItems() {
      if (!this.selectedWarrantyIds.length) return []
      return this.listItem.filter((i) => this.selectedWarrantyIds.includes(i.id))
    },
    ...mapGetters(['breadcrumbs', 'pageTitle', 'layoutConfig']),
    loaderEnabled() {
      return !/false/.test(this.layoutConfig('loader.type'))
    },
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig('loader.logo')
    },
    currentPage() {
      return Number(this.$route.query.page) || 1
    },
    pageType() {
      if (this.$route.path.includes('/receptions')) {
        return 'reception'
      }
      if (this.$route.path.includes('/dispatches')) {
        return 'dispatch'
      }
      return 'dispatch'
    },
    addNewRoute() {
      return '/dispatches/info'
    },
    title() {
      return 'Danh sách Điều phối'
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: this.title }])
  },
  watch: {},
  beforeRouteLeave(to, _from, next) {
    if (to.name === 'warranty-dispatch-info') {
      sessionStorage.setItem(
        'warranty-dispatch-filter',
        JSON.stringify({ apiParams: this.apiParams, limit: this.limit }),
      )
    }
    next()
  },
  async created() {
    try {
      const [{ stores, currentStoreId, currentStoreName, currentStoreShortName }, warrantyServices, companies] =
        await Promise.all([this.fetchStoreByUser(), getWarrantyServices(), this.fetchCompanies()])
      this.warrantyServiceOptions = warrantyServices
      this.listCompany = [{ id: null, name: 'Tất cả doanh nghiệp' }, ...companies]
      this.currentStoreId = currentStoreId
      this.optionStores = this.mapDataTreeSelect(stores || [], ['id', 'name', 'shortName'])
      if (currentStoreId) {
        this.apiParams.storeIds = [
          {
            id: currentStoreId,
            name: currentStoreName || '',
            shortName: currentStoreShortName || currentStoreName || '',
          },
        ]
      }
      const { data: allStores } = await this.fetchStores()
      this.allOptionStores = this.mapDataTreeSelect(allStores || [], ['id', 'name', 'shortName'])
    } catch (e) {
      this.optionStores = []
      this.allOptionStores = []
      handleError(e)
    }
    const saved = sessionStorage.getItem('warranty-dispatch-filter')
    if (saved) {
      try {
        const { apiParams, limit } = JSON.parse(saved)
        if (apiParams) this.apiParams = apiParams
        if (limit) { this.limit = limit; this.selectedPageSize = limit }
      } catch {}
      sessionStorage.removeItem('warranty-dispatch-filter')
    }
    this.fetchData()
  },
  methods: {
    showDeleteAlert,
    onFilter(params) {
      this.apiParams = { ...params }
      this.$route.query.page = 1
      this.$router.push({
        name: this.$route.name,
      })
      this.fetchData()
    },
    onReset(params) {
      this.apiParams = { ...params }
      this.selectedPageSize = null
      this.limit = 10
      this.fetchData()
    },
    onPageSizeChange(newSize) {
      this.selectedPageSize = newSize
      this.limit = newSize || 10
      this.fetchData()
    },
    onPageChange(page) {
      this.$router.push({
        name: this.$route.name,
        query: { ...this.$route.query, page },
      })
      this.fetchData()
    },
    async editItem(item) {
      if (
        item.transferStatus === WARRANTY_TRANSFER_STATUS.PENDING &&
        item.storeId === this.currentStoreId
      ) {
        const h = this.$createElement
        const messageVNode = h('div', {
          domProps: {
            innerHTML: `Vui lòng xác nhận đã nhận IMEI <strong>${item.imeiCode}</strong> của phiếu bảo hành <strong>#${item.id}</strong> để tiếp tục chỉnh sửa.`,
          },
        })
        const isConfirm = await this.$bvModal.msgBoxConfirm(messageVNode, {
          title: 'Yêu cầu xác nhận nhận hàng',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'primary',
          okTitle: 'Xác nhận và Chỉnh sửa',
          cancelTitle: 'Hủy',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        })

        if (!isConfirm) return

        try {
          const id = item.id || item.warrantyId
          await confirmWarrantyTransfer(id)
        } catch (err) {
          return
        }
      }

      this.$router.push({
        name: 'warranty-dispatch-info',
        query: { id: item.id, action: PAGE_ACTION.UPDATE },
      })
    },
    viewWarrantyDetail(item) {
      if (!item?.id) return
      this.$router.push({
        name: 'warranty-dispatch-info',
        query: { id: item.id, action: 'view' },
      })
    },
    showModalChangeStatus() {
      if (!this.countWarrantySelected) {
        makeToastFaile('Chưa có phiếu nào được chọn')
        return
      }
      this.$refs.warrantyChangeStatusModalRef?.show()
    },
    onOpenChangeStatusModal() {
      this.$nextTick(() => this.$refs.warrantyChangeStatusModalRef?.show())
    },
    async onCompleteWarranty(item) {
      if (!item || !item.id || this.isLoading) return
      this.isLoading = true
      try {
        const payload = {
          warranties: [{ id: item.id, status: WARRANTY_RECEPTION_STATUS.COMPLETED }],
        }
        const results = await bulkUpdateWarrantyStatus(payload)
        const result = Array.isArray(results) ? results.find((r) => r.id === item.id) : null
        if (result && result.isError) {
          makeToastFaile(result.message || 'Cập nhật thất bại')
        } else {
          makeToastSuccess('Hoàn thành phiếu bảo hành thành công')
          this.fetchData()
        }
      } catch (err) {
        makeToastFaile('Lỗi khi hoàn tất phiếu')
      } finally {
        this.isLoading = false
      }
    },
    async onReturnWarranty(item) {
      if (!item || !item.id || this.isLoading) return
      this.isLoading = true
      try {
        const payload = {
          warranties: [{ id: item.id, status: WARRANTY_RECEPTION_STATUS.RETURNED }],
        }
        const results = await bulkUpdateWarrantyStatus(payload)
        const result = Array.isArray(results) ? results.find((r) => r.id === item.id) : null
        if (result && result.isError) {
          makeToastFaile(result.message || 'Cập nhật thất bại')
        } else {
          makeToastSuccess('Trả bảo hành thành công')
          this.fetchData()
        }
      } catch (err) {
        makeToastFaile('Lỗi khi trả bảo hành')
      } finally {
        this.isLoading = false
      }
    },
    onRefreshWarranty() {
      this.selectedWarrantyIds = []
      this.fetchData()
      this.$refs.warrantyChangeStatusModalRef?.hide()
    },
    async openOutsourceForm(item) {
      const hasActive = await checkHasActiveOutsource(item?.id)
      if (hasActive) {
        makeToastFaile(
          'Máy này đang có phiếu outsource chưa hoàn thành. Vui lòng nhận hàng hoặc huỷ phiếu trước khi tạo mới.',
        )
        return
      }
      this.selectedWarrantyForOutsource = item
      this.$nextTick(() => this.$refs.outsourceFormRef?.show())
    },
    onOutsourceCreated() {
      this.selectedWarrantyForOutsource = null
      this.fetchData()
    },
    viewOutsource(item) {
      const id = item?.latestOutsource?.id
      if (!id) return
      const routeData = this.$router.resolve({
        name: 'warranty-outsource-info',
        query: { id },
      })
      window.open(routeData.href, '_blank')
    },
    onCreateLendingStockSlip(item) {
      if (!item?.id) return
      this.$router
        .push({
          name: 'add-lending-stockslip',
          query: { billId: item.id },
        })
        .catch(() => {})
    },
    mapDataTreeSelect(items = [], keys = ['id', 'name', 'shortName']) {
      if (!items || !items.length) return []
      const [idKey, nameKey, shortNameKey] = keys
      return items.map((item) => ({
        id: item[idKey],
        name: item[nameKey] || item[shortNameKey] || '',
        shortName: item[shortNameKey] || item[nameKey] || '',
      }))
    },
    getParamFilters() {
      return {
        page: this.$route.query.page || 1,
        limit: this.limit,
        id: this.apiParams.id,
        code: this.apiParams.code,
        imeiCode: this.apiParams.imeiCode && this.apiParams.imeiCode.trim(),
        customerPhone: this.apiParams.customerPhone && this.apiParams.customerPhone.trim(),
        customerName: this.apiParams.customerName && this.apiParams.customerName.trim(),
        startDate: formatDBDate(this.apiParams.startDate),
        endDate: formatDBDate(this.apiParams.endDate),
        status: this.apiParams.status,
        storeIds: (this.apiParams.storeIds || []).map((s) => s.id),
        previousStoreIds: (this.apiParams.previousStoreIds || []).map((s) => s.id),
        criteriaIds: (this.apiParams.criteriaIds || []).map((s) => s.id),
        transferStatus: (this.apiParams.transferStatus || []).map((s) => s.id),
        mode: 'dispatch',
        productName: this.apiParams.productName || null,
        primaryTechnicianId: this.apiParams.primaryTechnicianId || null,
        inspectedByEmployeeId: this.apiParams.inspectedByEmployeeId || null,
        warrantyServiceId: this.apiParams.warrantyServiceId || null,
        companyId: this.apiParams.companyId || null,
        creditUnitIds: (this.apiParams.creditUnitIds || []).map((u) => u.id),
        paymentCode: this.apiParams.paymentCode || null,
      }
    },
    async fetchData() {
      if (this.isLoading) return

      this.isLoading = true
      this.page = this.$route.query.page || 1

      try {
        const params = this.getParamFilters()
        const dataset = await getWarranties(params)

        this.totalItems = dataset.totalRow || 0
        this.numberOfPage = dataset.totalPage || 1
        this.listItem = (dataset.dataset || []).map((item) => mapWarrantyListItem(item))
      } catch (error) {
        console.error('Error fetching data:', error)
        this.totalItems = 0
        this.numberOfPage = 1
        this.listItem = []
      } finally {
        this.isLoading = false
      }
    },
    async onOpenChangeStore(item) {
      this.changeStoreWarranty = item
      this.showChangeStoreModal = true
    },
    async onSaveChangeStore({ warrantyId, storeId }) {
      if (!warrantyId || !storeId) return
      this.isChangingStore = true
      try {
        await changeWarrantyStore(warrantyId, storeId)
        this.showChangeStoreModal = false
        this.fetchData()
      } catch (e) {
        // handleError already called in API
      } finally {
        this.isChangingStore = false
      }
    },
    async onConfirmTransfer(item) {
      if (!item || (!item.id && !item.warrantyId)) return
      const id = item.id || item.warrantyId

      const h = this.$createElement
      const messageVNode = h('div', {
        domProps: {
          innerHTML: `Bạn có chắc chắn đã nhận IMEI <strong>${item.imeiCode}</strong> của phiếu bảo hành <strong>#${id}</strong> không?`,
        },
      })
      const isConfirm = await this.$bvModal.msgBoxConfirm(messageVNode, {
        title: 'Xác nhận nhận máy',
        size: 'md',
        buttonSize: 'sm',
        okVariant: 'primary',
        okTitle: 'Xác nhận',
        cancelTitle: 'Hủy',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
      })

      if (!isConfirm) return

      try {
        await confirmWarrantyTransfer(id)
        this.fetchData()
      } catch (err) {
        // handled in API
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.warranty {
  .icon:hover {
    background-color: #90c6fc;
  }

  .bootstrap-datetimepicker-widget.dropdown-menu {
    width: 21em;
  }
}
</style>

<style scoped>
.table th,
.table td {
  padding: 0.75rem;
  vertical-align: middle;
  border-top: 1px solid #ecf0f3;
}

.table.b-table.table-sm > thead > tr > [aria-sort]:not(.b-table-sort-icon-left),
.table.b-table.table-sm > tfoot > tr > [aria-sort]:not(.b-table-sort-icon-left) {
  background-position: right calc(1.5rem / 2) center;
  padding-right: calc(0.3rem + 0.65em);
}
</style>
